import { render, staticRenderFns } from "./NfcePanel.vue?vue&type=template&id=57a35486&scoped=true&"
import script from "./NfcePanel.vue?vue&type=script&lang=js&"
export * from "./NfcePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a35486",
  null
  
)

export default component.exports